import { render, staticRenderFns } from "./LedgerAccountWisePrintReport.vue?vue&type=template&id=65822fef&scoped=true&"
import script from "./LedgerAccountWisePrintReport.vue?vue&type=script&lang=js&"
export * from "./LedgerAccountWisePrintReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65822fef",
  null
  
)

export default component.exports